import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface JsonPopupData {
  title: string;
  json: any;
}

@Component({
  selector: 'app-json-popup',
  templateUrl: './json-popup.component.html',
  styleUrls: ['./json-popup.component.scss']
})
export class JsonPopupComponent {

  formattedJson: string;

  constructor(
    public dialogRef: MatDialogRef<JsonPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: JsonPopupData,
    private snackBar: MatSnackBar
  ) {
    this.formattedJson = this.formatJson(data.json);
  }

  formatJson(data: any): string {
    if (!data) return '';
    if (typeof data === 'string') {
      try {
        const parsed = JSON.parse(data);
        return JSON.stringify(parsed, null, 2);
      } catch (e) {
        return data;
      }
    }
    return JSON.stringify(data, null, 2);
  }

  copyToClipboard() {
    navigator.clipboard.writeText(this.formattedJson).then(() => {
      this.snackBar.open('JSON copied to clipboard', 'Close', {
        duration: 2000,
        horizontalPosition: 'right',
        verticalPosition: 'top',
      });
    }).catch((error) => {
      console.error('Failed to copy to clipboard:', error);
      this.snackBar.open('Failed to copy to clipboard', 'Close', {
        duration: 3000,
        horizontalPosition: 'right',
        verticalPosition: 'top',
      });
    });
  }

  close() {
    this.dialogRef.close();
  }
}